import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import playstote from "../Assets/google-play-badge.png"
import logo from "../Assets/logo (6).png"
const ModernTravelsHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    setMobileMenuOpen(false); // Close mobile menu after navigation
  };

  return (
    <div className="bg-gray-50">
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-yellow-400 to-yellow-300 px-4 py-2">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-end items-center gap-4 text-sm">
          <a href="tel:9100390049" className="text-gray-800 hover:text-gray-900 font-medium flex items-center gap-1">
            <span className="text-red-600">📞</span> 9100390049 | 9100390049
          </a>
          <a href="mailto:shreepujatraveldesk@gmail.com" className="text-gray-800 hover:text-gray-900 font-medium flex items-center gap-1">
            <span className="text-red-600">✉</span> shreepujatraveldesk@gmail.com
          </a>
        </div>
      </div>

      {/* Main Header */}
      <header className="shadow-lg" style={{ backgroundColor: 'rgba(65, 1, 150, 1)' }}>
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo - Clickable to Home */}
            <Link to="/" className="flex items-center gap-3 no-underline">
              <div className="w-16 h-16 bg-white rounded-lg flex items-center justify-center shadow-md">
                <div className="text-red-600 font-bold text-2xl">
                 <img src={logo} alt="Logo" className="w-18 h-20 object-contain"/>
                </div>
              </div>
              <div className="text-white">
                <div className="text-xl font-bold leading-tight">Shree Puja</div>
                <div className="text-xl font-bold leading-tight">TRAVELS</div>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              <Link 
                to="/" 
                className="text-white hover:text-yellow-300 font-medium transition-colors no-underline"
              >
                Home
              </Link>
              
              <div className="relative group">
                <button className="text-white hover:text-yellow-300 font-medium transition-colors flex items-center gap-1">
                  Book Your Cab?
                  <span className="text-xs">▼</span>
                </button>
                <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                  <Link 
                    to="/quick-booking" 
                    className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-purple-700 no-underline"
                  >
                    Quick Booking
                  </Link>
                  {/* <Link 
                    to="/cancel-ticket" 
                    className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-purple-700 no-underline"
                  >
                    Cancel Ticket
                  </Link>
                  <Link 
                    to="/ticket-status" 
                    className="block px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-purple-700 no-underline"
                  >
                    Ticket Status
                  </Link> */}
                </div>
              </div>
              
              {/* <Link 
                to="/track-bus" 
                className="text-white hover:text-yellow-300 font-medium transition-colors no-underline"
              >
                Track Bus
              </Link> */}

               <Link 
                to="/about" 
                className="text-white hover:text-yellow-300 font-medium transition-colors no-underline"
              >
                About Us
              </Link>
              
              <Link 
                to="/contact" 
                className="text-white hover:text-yellow-300 font-medium transition-colors no-underline"
              >
                Contact
              </Link>

              {/* Other Links */}
             
              
              {/* <Link 
                to="/routes" 
                className="text-white hover:text-yellow-300 font-medium transition-colors no-underline"
              >
                Our Routes
              </Link> */}
              
              <Link 
                to="/faq" 
                className="text-white hover:text-yellow-300 font-medium transition-colors no-underline"
              >
                FAQ
              </Link>
            </nav>

            {/* Desktop Action Buttons */}
            <div className="hidden lg:flex items-center gap-3">
              {/* <button 
                onClick={() => handleNavigation('/customer-login')}
                className="bg-yellow-400 text-gray-900 px-6 py-2.5 rounded-full font-semibold hover:bg-yellow-300 transition-colors flex items-center gap-2 shadow-lg cursor-pointer"
              >
                <span className="text-lg">👤</span>
                Customer Login
              </button> */}
              <button 
                onClick={() => handleNavigation('/login')}
                className="bg-yellow-400 text-gray-900 px-6 py-2.5 rounded-full font-semibold hover:bg-yellow-300 transition-colors flex items-center gap-2 shadow-lg cursor-pointer"
              >
                {/* <span className="text-lg">🔐</span> */}
                Login
              </button>
              <a 
                href="https://play.google.com/store/apps" 
                target="_blank" 
                rel="noopener noreferrer"
                className="cursor-pointer"
              >
                <img src={playstote} alt="Get it on Google Play" className="h-12 object-contain"/>
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-white p-2 cursor-pointer"
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="lg:hidden py-4 border-t border-purple-700">
              <nav className="flex flex-col gap-4">
                <Link 
                  to="/" 
                  className="text-white hover:text-yellow-300 font-medium py-2 no-underline"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Home
                </Link>
                
                <div className="flex flex-col gap-2">
                  <span className="text-white font-medium py-2">Book Your Cab?</span>
                  <div className="pl-4 flex flex-col gap-2">
                    <Link 
                      to="/quick-booking" 
                      className="text-white hover:text-yellow-300 font-medium py-1 no-underline"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Quick Booking
                    </Link>
                    {/* <Link 
                      to="/cancel-ticket" 
                      className="text-white hover:text-yellow-300 font-medium py-1 no-underline"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Cancel Ticket
                    </Link>
                    <Link 
                      to="/ticket-status" 
                      className="text-white hover:text-yellow-300 font-medium py-1 no-underline"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Ticket Status
                    </Link> */}
                  </div>
                </div>
                
                {/* <Link 
                  to="/track-bus" 
                  className="text-white hover:text-yellow-300 font-medium py-2 no-underline"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Track Bus
                </Link> */}
                
                <Link 
                  to="/contact" 
                  className="text-white hover:text-yellow-300 font-medium py-2 no-underline"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contact
                </Link>
                
                <Link 
                  to="/about" 
                  className="text-white hover:text-yellow-300 font-medium py-2 no-underline"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  About Us
                </Link>
                
                {/* <Link 
                  to="/routes" 
                  className="text-white hover:text-yellow-300 font-medium py-2 no-underline"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Our Routes
                </Link> */}
                
                <Link 
                  to="/faq" 
                  className="text-white hover:text-yellow-300 font-medium py-2 no-underline"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  FAQ
                </Link>

                <div className="flex flex-col gap-3 pt-4 border-t border-purple-700">
                  {/* <button 
                    onClick={() => handleNavigation('/customer-login')}
                    className="bg-yellow-400 text-gray-900 px-6 py-2.5 rounded-full font-semibold hover:bg-yellow-300 transition-colors flex items-center justify-center gap-2 cursor-pointer"
                  >
                    <span className="text-lg">👤</span>
                    Customer Login
                  </button> */}
                  <button 
                    onClick={() => handleNavigation('/login')}
                    className="bg-yellow-400 text-gray-900 px-6 py-2.5 rounded-full font-semibold hover:bg-yellow-300 transition-colors flex items-center justify-center gap-2 cursor-pointer"
                  >
                    <span className="text-lg">🔐</span>
                    Login
                  </button>
                  <a 
                    href="https://play.google.com/store/apps" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-black text-white px-4 py-3 rounded-lg hover:bg-gray-800 transition-colors flex items-center justify-center gap-2 no-underline cursor-pointer"
                  >
                    <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
                      <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                    </svg>
                    <div className="text-left">
                      <div className="text-xs">GET IT ON</div>
                      <div className="text-sm font-bold">Google Play</div>
                    </div>
                  </a>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>
    </div>
  );
};

export default ModernTravelsHeader;